const initialState = {
  shouldOpenNext: true
};

function PopupCertificateReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_SHOULD_OPEN_NEXT_TIME':
      return {
        ...state,
        shouldOpenNext: action.value.shouldOpenNext
      };
    default:
      return state;
  }
}

export default PopupCertificateReducer;
